export const carouselInicio = [
    {
        imagen: "../assets/imgs/Carousel/teatro.jpeg",
        url: "https://www.facebook.com/CECULTAH/",
        titulo: "Teatro Hidalgo Bartolomé de Medina",
        descripcion: "El Teatro Hidalgo Bartolomé de Medina es uno de los recintos culturales más emblemáticos de Pachuca. Inaugurado en 1957, su diseño está inspirado en el histórico Teatro Bartolomé de Medina, que formó parte de la vida cultural de la ciudad durante más de medio siglo."
    },
    {
        imagen: "../assets/imgs/Carousel/Bartolome_3.jpg",
        url: "https://www.facebook.com/CECULTAH/",
        titulo: "Teatro Hidalgo Bartolomé de Medina",
        descripcion: "Desde 1987, el teatro funciona como un espacio cultural de usos múltiples donde se realizan obras de teatro, conciertos, conferencias, exposiciones, eventos académicos y presentaciones de danza, consolidándose como un punto de encuentro para la cultura y el arte."
    },
    {
        imagen: "../assets/imgs/Carousel/Bartolome_8.jpg",
        url: "https://www.facebook.com/CECULTAH/",
        titulo: "Escenario",
        descripcion: "dispone de un escenario de 8 × 6 metros, camerinos y espacios complementarios para actividades culturales y académicas"
    },
    {
        imagen: "../assets/imgs/Carousel/Bartolome_9.jpg",
        url: "https://www.facebook.com/CECULTAH/",
        titulo: "Capacidad y distribución",
        descripcion: "El Teatro Hidalgo Bartolomé de Medina cuenta con una capacidad para 430 espectadores, distribuidos en dos niveles: 174 lugares en planta baja y 256 en planta alta, que permiten una excelente visibilidad del escenario desde cualquier ubicación."
    },
   
]